import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import { resolvePlatformAdmin } from '@/lib/platform/usePlatformAdmin';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function NoInvite() {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;
    let cancelled = false;
    (async () => {
      if (user?.id && await resolvePlatformAdmin(user.id)) {
        if (!cancelled) navigate('/app/platform/tenants', { replace: true });
        return;
      }
      // Sign non-admin users out so they don't sit in a half-state.
      await supabase.auth.signOut();
    })();
    return () => { cancelled = true; };
  }, [user?.id, isLoading, navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-xl font-display">No invitation found</CardTitle>
          <CardDescription>
            This email isn\u2019t on the invite list yet. Ask your admin to invite this address,
            then sign in again.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button className="w-full" onClick={() => navigate('/auth/signin')}>
            Try a different email
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
